module.exports = __webpack_public_path__ + "img/img_sb.44c42a40.jpg";